(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/vouchers/pay.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/vouchers/pay.js');
"use strict";

class PayVoucher extends svs.tur.payment.api.jupiter.base.PayBase {
  constructor(_ref) {
    let {
      payableObj
    } = _ref;
    const jupiterOptions = {
      path: '/ticket/1/giftvouchers'
    };
    super({
      wagerModel: payableObj,
      jupiterOptions
    });
    this.payableObj = payableObj;
    this.skipNotifications = true;
    this.price = payableObj.price;
    this.deliveryDate = payableObj.deliveryDate;
    this.products = payableObj.products;
    this.recipientName = payableObj.recipientName;
    this.contactInfo = payableObj.recipientPhoneNumber || this.recipientEmail;
  }
  showConfirmDialog() {
    new svs.tur.payment.api.jupiter.vouchers.dialogs.PaymentConfirm({
      price: this.price,
      products: this.products,
      onCancel: () => {
        this.destroy();
      },
      onConfirm: () => {
        this.sendPayment();
      }
    });
  }
  showSuccessDialog() {
    const {
      DIALOG_SUCCESS_CONFIRM
    } = svs.tur.payment.constants.events;
    new svs.tur.payment.api.jupiter.vouchers.dialogs.PaymentSuccess({
      products: this.products,
      contactInfo: this.contactInfo,
      recipientName: this.recipientName,
      deliveryDate: this.deliveryDate,
      onConfirm: () => {
        this.trigger(DIALOG_SUCCESS_CONFIRM);
        this.destroy();
      }
    });
  }
  onPaymentError(_ref2) {
    let {
      xhr,
      textStatus,
      errorThrown
    } = _ref2;
    svs.tur.payment.logger.warn("failure (".concat(JSON.stringify(xhr), ", ").concat(textStatus, ", ").concat(errorThrown, ")"));
    const {
        PAYMENT_ERROR
      } = svs.tur.payment.constants.events,
      paymentErrorHandler = new svs.tur.payment.api.jupiter.vouchers.services.PaymentError({
        xhr
      }),
      {
        errorType
      } = paymentErrorHandler.getErrorData();
    paymentErrorHandler.showErrorDialog();
    this.trigger(PAYMENT_ERROR, {
      errorType
    });
    this.destroy();
  }

  sendAnalytics(_ref3) {
    let {
      giftedVouchers
    } = _ref3;
    try {
      const slicedId = giftedVouchers[0] && giftedVouchers[0].VoucherId.slice(0, 8);
      const items = [];
      this.payableObj.products.forEach(voucher => {
        for (let i = 0; i < voucher.count; i++) {
          items.push(this.createVoucherTransationItem(voucher));
        }
      });
      const trans = new svs.components.analytics.transaction(slicedId, svs.utils.format.CurrencyFromJupiterString(this.payableObj.price), items, 0, 0, undefined, 'VOUCHER');
      svs.components.analytics.trackTransaction(trans);
    } catch (error) {
      svs.tur.payment.logger.error('Could not track vouchers', error);
    }
  }
  createVoucherTransationItem(voucher) {
    return new svs.components.analytics.transactionItem('VOUCHER', voucher.name, svs.utils.format.CurrencyFromJupiterString(voucher.value), 1, {
      gameType: voucher.type
    });
  }
  initialize(branding) {
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      const loginBrand = branding === 'triss' ? 'triss' : 'tur';
      svs.components.customer_login.login({
        returnNewCustomer: true,
        extraParams: {
          amount: parseInt(this.price, 10),
          product: loginBrand,
          subscription: false,
          gift: false,
          branding: loginBrand
        }
      });
      return;
    }
    super.initialize();
  }
}
svs.tur.payment.api.jupiter.vouchers.Pay = PayVoucher;

 })(window);